import * as React from "react";
import { imagePathurl } from "../../utils/utils";

enum KEYPRESS {
    DOWN = "ArrowDown",
    UP = "ArrowUp",
    ESC = "Escape",
    ENTER = "Enter",
}

/** @description Functional component to render the dropdown */
class Dropdown extends React.Component<any, any> {
    private readonly dropDownRef: React.LegacyRef<HTMLUListElement>;
    constructor(props) {
        super(props);
        this.dropDownRef = React.createRef();
        this.state = {
            dropDownValue: props.menuItems[0].label,
            isDropDown: false,
            label: "",
        };
    }

    /** @description React Life cycle method
     * it will invoke, when component is mounted.
     */
    componentDidMount() {
        // this.setInitialValue();
        if (!!this.props.selectedOption){
            const selectedValue = this.props.menuItems.find((option) => option.value === this.props.selectedOption);
            this.setState({ dropDownValue: selectedValue.label });
        }
    }

    componentDidUpdate(prevProps, prevState): void {
        if (prevProps.resetDropdown !== this.props.resetDropdown && this.props.resetDropdown){
            this.setState({ dropDownValue: this.props.menuItems[0].label });
        }
        if (prevProps.selectedOption !== this.props.selectedOption && !!this.props.selectedOption){
            const selectedValue = this.props.menuItems.find((option) => option.value === this.props.selectedOption);
            if (selectedValue){
                this.setState({ dropDownValue: selectedValue.label });
            } else {
                this.setState({ dropDownValue: this.props.menuItems[0].label });
            }
        }
    }

    toggleDropDown = () => {
        const { isDropDown } = this.state;
        this.setState({
            isDropDown: !isDropDown,
        });
    };

    onDropDownChange = (value, reportType) => {
        this.setState({
            dropDownValue: value,
        });
        this.props.onChangeReportType(reportType);
    };
    hideDropDown = () => {
        this.setState({ isDropDown: false });
    };
    showDropDown = (event: any) => {
        const { isDropDown } = this.state;
        const { key } = event;

        if (Object.values(KEYPRESS).includes(key)) {
            if (key === KEYPRESS.ESC) {
                return this.hideDropDown();
            }
            if (key === KEYPRESS.DOWN) {
                if (!isDropDown) {
                    this.toggleDropDown();
                }
            }
        }
    };
    render() {
        const { dropDownValue, isDropDown } = this.state;
        const getimagePath = imagePathurl();
        return (
            <div className="gaf-dropdown-container">
                <div
                    className={`gaf-dropdown ${this.props.isError ? "gaf-dropdown-error" : ""}`}
                    tabIndex={0}
                    onClick={this.toggleDropDown}
                    onBlur={this.hideDropDown}
                    onKeyDown={this.showDropDown}
                >
                    <img src={`${getimagePath}chevron-down.png`} className="chevron-down-thickred" />
                    <p className="dropdown-selection" title={dropDownValue}>
                        {dropDownValue}
                    </p>
                    {isDropDown && (
                        <ul ref={this.dropDownRef} className={"dropdown-list"}>
                            {this.props.menuItems.map((option, index) => {
                                return (
                                    <li
                                        key={`${option.value}-${index}`}
                                        id={option.value || "menuItem" + index}
                                        onClick={(e) => {
                                            this.onDropDownChange(option.label, option.value);
                                        }}
                                    >
                                        {option.label}
                                    </li>
                                );
                            })}
                        </ul>
                    )}
                </div>
            </div>
        );
    }
}

export default Dropdown;
